import React from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import FhirLoader from '../../../../FhirLoader'
import { InsurancePlanTable } from '@teschglobal/tg-fhir-react-components'
import { InsurancePlan } from '@teschglobal/tg-fhir-react-components/dist/types'

type InsurancePlanListProps = {
    insurancePlans: ProviderResponse<InsurancePlan>
    isFetching: boolean
    isLoading: boolean
    isSuccess: boolean
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void
    clickViewDataLink: (insurancePlan: InsurancePlan) => void
}

const InsurancePlanList: React.FC<InsurancePlanListProps> = ({
    insurancePlans,
    clickViewDataLink,
    isFetching,
    isLoading,
    isSuccess,
    totalPages,
    currentPage,
    handleChangePage,
}) => {

    const { data: environment } = useEnvironment()

    const rows: InsurancePlan[] = insurancePlans?.data ?? []

    return (
        <>
            <h3>InsurancePlan</h3>
            {(isLoading || isFetching) ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        insurancePlans?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{insurancePlans?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <InsurancePlanTable
                        insurancePlans={rows}
                        onRowLinkClick={clickViewDataLink}
                    />
                    {
                        insurancePlans?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default InsurancePlanList